import React from "react";

export default function InputTextoPadron({
  name,
  value,
  onChange,
  className = "",
  permiteEspacios = true,
  ...props
}) {
  const claseFinal = `form-control ${className}`.trim();

  function formatearTexto(texto) {
    let resultado = texto
      .toUpperCase()
      .normalize("NFD")
      .replace(/([AEIOU])\u0301/g, "$1") // quita las tildes de las vocales
      .replace(/U\u0308/g, "U"); // quita la diéresis de la U

    resultado = resultado.replace(/Ñ/g, "Ñ");

    if (!permiteEspacios) {
      resultado = resultado.replace(/\s/g, ""); // elimina espacios
    }

    return resultado;
  }

  const handleChangeInterno = (e) => {
    const val = formatearTexto(e.target.value);

    onChange({ target: { name, value: val, type: "text" } });
  };

  return (
    <input
      type="text"
      name={name}
      value={value}
      className={claseFinal}
      onChange={handleChangeInterno}
      {...props}
    />
  );
}
